import React from "react";
import { Rating } from 'components';

export default () => (
  <div className='Review'>

    <Rating score={4}/>

    <div className="Review-Title">Nice ride and good looking!</div>

    <div className="Review-Metadata">
      <span className="Review-Author">By SoccerMom254</span>
      <span className="Review-Date">January 25 2019</span>
      <span className="Verified">Verified Purchase</span>
    </div>

    <div className="Review-Comment">
      Overall I enjoy using this jogger, the pros outweigh the cons. I'm an avid gym goer and beginner jogger with two girls, a 3 year old and an 8 month old. I've used it a couple of times a week for about a month.
    </div>

  </div>
);
